import {Injectable} from '@angular/core';
import {Storage} from '@ionic/storage-angular';
import {ToastController} from '@ionic/angular';
import {HttpClient} from '@angular/common/http';
//import {TranslateService} from '@ngx-translate/core';
import {environment} from 'src/environments/environment';

const STORAGE_REQ_KEY = 'storedreq';

interface StoredRequest {
  url: string;
  type: string;
  data: any;
  time: number;
  id: string;
}

@Injectable({
  providedIn: 'root'
})
export class OfflineManagerService {
  token: any;
  constructor(
    private storage: Storage,
    private http: HttpClient,
    private toastController: ToastController,
    //private translate: TranslateService
  ) {
    this.storage.get('token').then(data => {
      if (data) {
        this.token = data;
      }
    });
  }

  async checkForEvents() {
    const storedObj1 = await this.storage.get(STORAGE_REQ_KEY);

    if (storedObj1 != null) {
      const storedObj = JSON.parse(storedObj1);
      this.sendRequests(storedObj);
      await this.storage.remove(STORAGE_REQ_KEY);
    }
  }

  async storeRequest(url, type, data) {
    /*const toast = this.toastController.create({
      message: this.translate.instant('network.upload_event'),
      duration: 3000,
      position: 'bottom'
    });*/
    //toast.then(toastRet => toastRet.present());
    if (type !== 'PUT') {
      try {
        data.start_date.setHours(
          data.start_date.getHours() - data.start_date.getTimezoneOffset() / 60
        );
        data.end_date.setHours(data.end_date.getHours() - data.end_date.getTimezoneOffset() / 60);
      } catch (e) {
        // console.log('Error on store request: ', e);
      }
    }

    const action: StoredRequest = {
      url,
      type,
      data,
      time: new Date().getTime(),
      id: Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, '')
        .substr(0, 5)
    };

    let stored = await this.storage.get(STORAGE_REQ_KEY);
    if (stored != null) {
      stored = JSON.parse(stored);
      stored.push(action);
    } else {
      stored = [action];
    }
    await this.storage.set(STORAGE_REQ_KEY, JSON.stringify(stored));
  }

  sendRequests(operations: StoredRequest[]) {
    // console.log('all requests', operations);
    for (const op of operations) {
      // console.log('Make one request: ', op);
      if (op.type === 'GET') {
        this.http.get(op.url, op.data);
      }
      if (op.type === 'POST') {
        if (op.data.employee == null) {
          this.http
            .post(`${environment.url}/bucket/${environment.buckets.bookings}/data`, op.data)
            .subscribe();
        } else {
          this.http.post(op.url, op.data, {observe: 'response'}).subscribe();
        }
      }
      if (op.type === 'PUT') {
        this.http.put(
          // eslint-disable-next-line no-underscore-dangle
          `${environment.url}/bucket/${environment.buckets.bookings}/data/${op.data._id}`,
          {
            ...op.data
          }
        );
      }
    }

    // Send out all local events and return once they are finished
  }
}
